import styled from 'styled-components'
import Button from '@mui/material/Button'
import Paper from '@mui/material/Paper'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Dialog from '@mui/material/Dialog'

export const MessageText = styled.p`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  padding: 40px 20px;
`

export const CustomRoomTableContainer = styled(TableContainer) <{
  component: React.ElementType
}>`
  max-height: 500px;
  background: rgba(26, 29, 41, 0.5);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  table {
    min-width: 650px;
  }

  .MuiTableCell-head {
    background: rgba(26, 29, 41, 0.8);
    color: rgba(255, 255, 255, 0.7);
    font-weight: 600;
  }

  .MuiTableCell-body {
    color: #fff;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }
`

export const TableRowWrapper = styled(TableRow)(
  ({ theme }) => `
  position: relative;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  .name {
    font-weight: 600;
    font-size: 0.9rem;
    color: rgba(255, 255, 255, 0.9);
  }

  .id {
    font-size: 0.7rem;
    color: rgba(255, 255, 255, 0.5);
    margin-top: 4px;
    font-family: monospace;
  }

  .description {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.7);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .creator {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 500;
    display: flex;
    align-items: center;
  }

  .player-count {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.7);

    svg {
      font-size: 0.9rem;
      opacity: 0.8;
    }
  }

  .join-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;

    .lock-icon {
      font-size: 0.9rem;
      color: #f9a825;
    }
  }
`
)

export const ActionButton = styled(Button)`
  background: linear-gradient(90deg, #426dea, #42eacb);
  color: #fff;
  border-radius: 12px;
  padding: 8px 16px;
  font-weight: 600;
  text-transform: none;
  transition: all 0.3s ease;
  border: none;

  &:hover {
    background: linear-gradient(90deg, #3a62d9, #3ad9bd);
    box-shadow: 0 5px 15px rgba(66, 109, 234, 0.3);
    transform: translateY(-2px);
  }

  &.MuiButton-outlined {
    background: transparent;
    border: 1px solid rgba(66, 109, 234, 0.5);
    color: #426dea;

    &:hover {
      background: rgba(66, 109, 234, 0.1);
      border-color: #426dea;
    }
  }
`

export const PasswordDialog = styled(Dialog)`
  .MuiDialog-paper {
    background: #222639;
    border-radius: 16px;
    padding: 16px;
    color: #fff;
  }

  .MuiDialogTitle-root {
    color: #fff;
    text-align: center;
    font-weight: 600;
  }

  .dialog-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }

  .MuiOutlinedInput-root {
    background: rgba(26, 29, 41, 0.5);
    border-radius: 12px;

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #426dea;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #42eacb;
    }
  }

  .MuiInputLabel-root {
    color: rgba(255, 255, 255, 0.7);

    &.Mui-focused {
      color: #42eacb;
    }
  }
`

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
` 